import { useCallback } from "react";
import { useLocalStorage } from "usehooks-ts";

export type MENU_TYPE = "main" | "settings";

export function useMenu(key: string, initial = "main") {
  const [menu, setMenu] = useLocalStorage(key, initial);
  return { setMenu, menu };
}
